/**
 * Client Features Service
 * Allows authenticated clients to fetch their enabled features
 */
import api from './api';

const clientFeaturesService = {
  /**
   * Get all features for the current authenticated client
   * @returns {Promise<Array>} List of features with is_enabled status
   */
  getMyFeatures: async () => {
    try {
      const response = await api.get('/client/features');
      return response.data;
    } catch (error) {
      console.error('Error fetching client features:', error);
      throw error;
    }
  },

  /**
   * Check if the current client has access to a specific feature
   * @param {string} featureKey - Feature key to check (e.g., 'qgames', 'flows')
   * @returns {Promise<Object>} Object with has_access boolean
   */
  checkFeatureAccess: async (featureKey) => {
    try {
      const response = await api.get(`/client/features/check/${featureKey}`);
      return response.data;
    } catch (error) {
      console.error(`Error checking feature access for ${featureKey}:`, error);
      return { has_access: false, feature_key: featureKey };
    }
  },

  /**
   * Check if a feature is enabled from the cached features list
   * @param {Array} features - Cached features list
   * @param {string} featureKey - Feature key to check
   * @returns {boolean} True if feature is enabled
   */
  isFeatureEnabled: (features, featureKey) => {
    if (!features || !Array.isArray(features)) return false;
    const feature = features.find(f => f.feature_key === featureKey);
    return feature ? feature.is_enabled : false;
  }
};

export default clientFeaturesService;
